import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom"; // ✅ Import Link
import axios from "axios";
import "../styles/Login.css";

const Login = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!username || !password) {
            setError("Username dan password harus diisi!");
            return;
        }

        try {
            const res = await axios.post("https://depotaircerdas.com/api/auth/login", {
                username,
                password
            });

            if (res.data.success && res.data.token) {
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("username", username);
                localStorage.setItem("is_super_admin", res.data.is_super_admin ? 'true' : 'false');
                
                onLoginSuccess();
                setMessage("Login berhasil!");

                if (res.data.is_super_admin) {
                    navigate("/admin/register", { replace: true });
                } else {
                    navigate("/dashboard", { replace: true });
                }
            } else {
                setError(res.data.message || "Login gagal! Periksa kembali username dan password.");
            }
        } catch (err) {
            console.error("Login error:", err.response ? err.response.data : err.message);
            setError(err.response?.data?.message || "Terjadi kesalahan saat login.");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                {/* ✅ PERUBAHAN DI SINI: Gunakan Link dari react-router-dom ke '/' */}
                <Link to="/" className="btn-back">⬅ Kembali</Link>
                
                <h2 className="login-title">Masuk ke Depot Air Cerdas</h2>
                
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                
                <form onSubmit={handleLogin} className="login-form">
                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn-login">Login</button>
                </form>
                
                <p className="register-link-text">Belum punya akun? <Link to="/register">Daftar</Link></p> {/* ✅ Gunakan Link di sini juga */}
            </div>
        </div>
    );
};

export default Login;